module.exports = __webpack_public_path__ + "static/media/designPatent_30-1018450.10f21209.png";